"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    radioCheckGroupLabel: {
      color: theme.palette.primary.main,
      display: "block",
      fontSize: ".75rem",
      fontWeight: "bold",
      marginBottom: 8,
      marginTop: 16
    },
    checkboxGroup: {
      margin: 0
    }
  };
};

exports.styles = styles;